var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    staticStyle: {
      "border-top-right-radius": "0px",
      "border-bottom-right-radius": "0px",
      "border-right": "0px"
    },
    attrs: {
      label: "Search Filters",
      items: _vm.filters,
      disabled: _vm.disabled,
      "item-text": "name",
      "item-value": "key",
      "background-color": "input",
      "menu-props": { offsetY: true, maxHeight: "600" },
      multiple: "",
      outlined: "",
      "hide-details": "",
      "small-chips": "",
      dense: ""
    },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function(ref) {
          var attrs = ref.attrs
          var item = ref.item
          return [
            item.key === "vendor_ids" && _vm.params.vendor_ids.length > 0
              ? _vm._l(_vm.selectedVendors, function(vendor) {
                  return _c(
                    "v-chip",
                    { key: vendor.id, attrs: { small: "" } },
                    [
                      _vm._v("\n        " + _vm._s(vendor.name) + "\n        "),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeVendor(vendor.id)
                            }
                          }
                        },
                        [_vm._v("\n          $delete\n        ")]
                      )
                    ],
                    1
                  )
                })
              : item.key === "item_sources" &&
                _vm.params.item_sources.length > 0
              ? _vm._l(_vm.selectedSources, function(source) {
                  return _c(
                    "v-chip",
                    { key: source.source_id, attrs: { small: "" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(source.display_name) +
                          "\n        "
                      ),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeSource(source)
                            }
                          }
                        },
                        [_vm._v("\n          $delete\n        ")]
                      )
                    ],
                    1
                  )
                })
              : ["private_label", "shipper_flag"].includes(item.key)
              ? [
                  _c(
                    "v-chip",
                    { key: item.key, attrs: { color: "primary", small: "" } },
                    [
                      _vm._v("\n        " + _vm._s(item.name) + "\n        "),
                      _c(
                        "v-icon",
                        {
                          attrs: { small: "", right: "" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(item.key, true)
                            }
                          }
                        },
                        [_vm._v("\n          $delete\n        ")]
                      )
                    ],
                    1
                  )
                ]
              : _c(
                  "v-chip",
                  _vm._b({ attrs: { small: "" } }, "v-chip", attrs, false),
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.getFilterText(item)) + "\n      "
                    ),
                    _c(
                      "v-icon",
                      {
                        attrs: { small: "", right: "" },
                        on: {
                          click: function($event) {
                            return _vm.removeFilter(item.key, true)
                          }
                        }
                      },
                      [_vm._v("\n        $delete\n      ")]
                    )
                  ],
                  1
                )
          ]
        }
      },
      {
        key: "item",
        fn: function(ref) {
          var item = ref.item
          var attrs = ref.attrs
          return [
            _c(
              "v-list-item",
              {
                style: item.type === "boolean" ? "display: none;" : "",
                attrs: { disabled: item.type === "boolean" }
              },
              [
                _c(
                  "v-list-item-content",
                  [
                    item.key === "vendor_ids"
                      ? _c("VendorSelect", {
                          attrs: { selectedVendors: _vm.selectedVendors },
                          on: {
                            "update:selectedVendors": function($event) {
                              _vm.selectedVendors = $event
                            },
                            "update:selected-vendors": function($event) {
                              _vm.selectedVendors = $event
                            }
                          }
                        })
                      : item.key === "item_sources"
                      ? _c("v-autocomplete", {
                          attrs: {
                            label: "Item Sources",
                            items: _vm.userSources,
                            "item-text": "display_name",
                            "item-value": "source_id",
                            multiple: "",
                            "deletable-chips": "",
                            "small-chips": "",
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            "return-object": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.selectedSources,
                            callback: function($$v) {
                              _vm.selectedSources = $$v
                            },
                            expression: "selectedSources"
                          }
                        })
                      : item.key === "departments"
                      ? _c("v-autocomplete", {
                          attrs: {
                            items: _vm.departments,
                            label: item.name,
                            dense: "",
                            "hide-details": "",
                            outlined: "",
                            clearable: "",
                            multiple: "",
                            "small-chips": "",
                            "deletable-chips": ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.checkDownstream(item)
                            },
                            "click:clear": function($event) {
                              return _vm.removeFilter(item.key)
                            }
                          },
                          model: {
                            value: _vm.params[item.key],
                            callback: function($$v) {
                              _vm.$set(_vm.params, item.key, $$v)
                            },
                            expression: "params[item.key]"
                          }
                        })
                      : item.key === "categories"
                      ? _c("v-autocomplete", {
                          attrs: {
                            items: _vm.categories,
                            label: item.name,
                            dense: "",
                            "hide-details": "",
                            outlined: "",
                            clearable: "",
                            multiple: "",
                            "small-chips": "",
                            "deletable-chips": ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.checkDownstream(item)
                            },
                            "click:clear": function($event) {
                              return _vm.removeFilter(item.key)
                            }
                          },
                          model: {
                            value: _vm.params[item.key],
                            callback: function($$v) {
                              _vm.$set(_vm.params, item.key, $$v)
                            },
                            expression: "params[item.key]"
                          }
                        })
                      : item.key === "subcategories"
                      ? _c("v-autocomplete", {
                          attrs: {
                            items: _vm.subcategories,
                            label: item.name,
                            dense: "",
                            "hide-details": "",
                            outlined: "",
                            clearable: "",
                            multiple: "",
                            "small-chips": "",
                            "deletable-chips": ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.checkDownstream(item)
                            },
                            "click:clear": function($event) {
                              return _vm.removeFilter(item.key)
                            }
                          },
                          model: {
                            value: _vm.params[item.key],
                            callback: function($$v) {
                              _vm.$set(_vm.params, item.key, $$v)
                            },
                            expression: "params[item.key]"
                          }
                        })
                      : item.key == "upc"
                      ? _c(
                          "div",
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: item.name,
                                "hide-details": "",
                                "background-color": "input",
                                prefix: item.prefix || null,
                                type: item.type,
                                autofocus:
                                  _vm.selectedFilters.length === 0 &&
                                  item.key === "description",
                                dense: "",
                                clearable: "",
                                outlined: ""
                              },
                              on: {
                                input: function($event) {
                                  attrs.inputValue
                                    ? null
                                    : _vm.handleInputValue(item)
                                },
                                "click:clear": function($event) {
                                  return _vm.removeFilter(item.key)
                                },
                                keydown: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.updateSearchFilters(true)
                                }
                              },
                              model: {
                                value: _vm.params["" + item.key],
                                callback: function($$v) {
                                  _vm.$set(_vm.params, "" + item.key, $$v)
                                },
                                expression: "params[`${item.key}`]"
                              }
                            }),
                            _vm._v(" "),
                            _vm.suggestedUpc && _vm.params.upc
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "upcConfirm",
                                    staticStyle: { color: "#333" }
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        "\n              Searching for " +
                                          _vm._s(_vm.suggestedUpc) +
                                          "\n              "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            "font-weight": "500",
                                            "text-decoration": "underline",
                                            "margin-left": "5px",
                                            "font-style": "normal"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit("updateUpc")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                undo\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-style": "normal",
                                            margin: "0px 10px"
                                          }
                                        },
                                        [_vm._v("|")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            "font-weight": "500",
                                            "text-decoration": "underline",
                                            "font-style": "normal"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit("searchSimilar")
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              search for similar UPC's\n              "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _c("v-text-field", {
                          attrs: {
                            label: item.name,
                            "hide-details": "",
                            "background-color": "input",
                            prefix: item.prefix || null,
                            type: item.type,
                            autofocus:
                              _vm.selectedFilters.length === 0 &&
                              item.key ===
                                (_vm.$auth.tenant === "alliance-retail-group"
                                  ? "item_id"
                                  : "description"),
                            dense: "",
                            clearable: "",
                            outlined: ""
                          },
                          on: {
                            input: function($event) {
                              attrs.inputValue
                                ? null
                                : _vm.handleInputValue(item)
                            },
                            "click:clear": function($event) {
                              return _vm.removeFilter(item.key)
                            },
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.updateSearchFilters(true)
                            }
                          },
                          model: {
                            value: _vm.params["" + item.key],
                            callback: function($$v) {
                              _vm.$set(_vm.params, "" + item.key, $$v)
                            },
                            expression: "params[`${item.key}`]"
                          }
                        })
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      },
      {
        key: "append-item",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "mx-10 my-4" },
              [
                _c(
                  "v-row",
                  { attrs: { align: "center", justify: "center" } },
                  _vm._l(_vm.booleanFilters, function(item) {
                    return _c(
                      "v-col",
                      {
                        key: item.key,
                        staticClass: "boolean",
                        attrs: { cols: "5" }
                      },
                      [
                        _c("v-switch", {
                          staticClass: "pa-0 ma-0",
                          attrs: {
                            label: item.name,
                            dense: "",
                            "hide-details": ""
                          },
                          on: {
                            click: function($event) {
                              _vm.selectedFilters.includes(item.key)
                                ? _vm.removeFilter(item.key)
                                : _vm.handleInputValue(item)
                            }
                          },
                          model: {
                            value: _vm.params["" + item.key],
                            callback: function($$v) {
                              _vm.$set(_vm.params, "" + item.key, $$v)
                            },
                            expression: "params[`${item.key}`]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.selectedFilters,
      callback: function($$v) {
        _vm.selectedFilters = $$v
      },
      expression: "selectedFilters"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14cf9124", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14cf9124","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/SearchFilters.vue
// module id = null
// module chunks = 